<template>
  <div class="my-process-designer">
    <div class="my-process-designer__header">
      <slot name="control-header"></slot>
      <el-button-group v-if="!$slots['control-header']">
        <el-popover placement="bottom" :width="100" trigger="hover">
          <template #reference>
            <el-button :size="headerButtonSize" :type="headerButtonType" icon="el-icon-more">下载文件</el-button>
          </template>
            <el-button :size="headerButtonSize" type="text" @click="downloadProcessAsXml">下载为XML文件</el-button>
            <br />
            <el-button :size="headerButtonSize" type="text" @click="downloadProcessAsSvg">下载为SVG文件</el-button>
            <br />
            <el-button :size="headerButtonSize" type="text" @click="downloadProcessAsBpmn">下载为BPMN文件</el-button>
        </el-popover>
        <el-button :size="headerButtonSize" :type="headerButtonType" icon="el-icon-folder-opened" @click="$refs.refFile.click()"
          >打开文件</el-button>
        <el-popover placement="bottom" :width="100" trigger="hover">
          <template #reference>
            <el-button :size="headerButtonSize" :type="headerButtonType" icon="el-icon-view">预览</el-button>
          </template>
            <el-button :size="headerButtonSize" type="text" @click="previewProcessXML">预览XML</el-button>
            <br />
            <el-button :size="headerButtonSize" type="text" @click="previewProcessJson">预览JSON</el-button>
        </el-popover>
        <el-button :size="headerButtonSize" :type="headerButtonType" icon="el-icon-folder-opened" @click="saveFlow"
        >保存文件</el-button>
        <el-tooltip effect="light" content="缩小视图">
          <el-button :size="headerButtonSize" :disabled="defaultZoom < 0.2" @click="processZoomOut" >
            <el-icon :size="16"><ZoomOut /></el-icon>
          </el-button>
        </el-tooltip>
        <el-button :size="headerButtonSize">{{ currentScale }}</el-button>
        <el-tooltip effect="light" content="放大视图">
          <el-button :size="headerButtonSize" :disabled="defaultZoom > 5" @click="processZoomIn" >
            <el-icon :size="16"><ZoomIn /></el-icon>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="light" content="重置视图并居中">
          <el-button :size="headerButtonSize" icon="el-icon-c-scale-to-original" @click="processReZoom" >
            <el-icon :size="16"><ScaleToOriginal /></el-icon>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="light" content="撤销">
          <el-button :size="headerButtonSize" :disabled="!revocable" @click="processUndo" >
            <el-icon :size="16"><RefreshLeft /></el-icon>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="light" content="恢复">
          <el-button :size="headerButtonSize" :disabled="!recoverable" @click="processRedo" >
            <el-icon :size="16"><RefreshRight /></el-icon>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="light" content="重新绘制">
          <el-button :size="headerButtonSize" icon="el-icon-refresh" @click="processRestart" >
            <el-icon :size="16"><Refresh /></el-icon>
          </el-button>
        </el-tooltip>
      </el-button-group>
      <!-- 用于打开本地文件-->
      <input type="file" id="files" ref="refFile" style="display: none" accept=".xml, .bpmn" @change="importLocalFile" />
    </div>
    <div class="my-process-designer__container">
      <div class="my-process-designer__canvas" ref="bpmn-canvas"></div>
    </div>
    <el-dialog title="预览" width="60%" v-model="previewModelVisible" append-to-body destroy-on-close>
<!--      <highlightjs :language="previewType" :code="previewResult" />-->
      <pre style="max-height: 500px;overflow-y: auto;" v-highlightjs="previewResult"><code class="javascript"></code></pre>
    </el-dialog>
  </div>
</template>

<script>
import BpmnModeler from "bpmn-js/lib/Modeler";
import DefaultEmptyXML from "./plugins/defaultEmpty";
// 翻译方法
import customTranslate from "./plugins/translate/customTranslate";
import translationsCN from "./plugins/translate/zh";
// 标签解析构建器
// import bpmnPropertiesProvider from "bpmn-js-properties-panel/lib/provider/bpmn";
// 标签解析 Moddle
import camundaModdleDescriptor from "./plugins/descriptor/camundaDescriptor.json";
import activitiModdleDescriptor from "./plugins/descriptor/activitiDescriptor.json";
import flowableModdleDescriptor from "./plugins/descriptor/flowableDescriptor.json";
// 标签解析 Extension
import camundaModdleExtension from "./plugins/extension-moddle/camunda";
import activitiModdleExtension from "./plugins/extension-moddle/activiti";
import flowableModdleExtension from "./plugins/extension-moddle/flowable";
// 引入json转换与高亮
import convert from "xml-js";
// import "highlight.js/styles/atom-one-dark-reasonable.css";
// app.use(hljs.vuePlugin);
// import Vue from "vue";
// import { createApp } from 'vue'
// import App from '../../App.vue'

import { ZoomOut, ZoomIn, ScaleToOriginal, RefreshLeft, RefreshRight, Refresh } from "@element-plus/icons-vue";
// const app = createApp(App);

export default {
  name: "MyProcessDesigner",
  componentName: "MyProcessDesigner",
  components: {
    ZoomOut, ZoomIn, ScaleToOriginal, RefreshLeft, RefreshRight, Refresh
  },
  props: {
    idName: Object,
    value: String, // xml 字符串
    translations: Object, // 自定义的翻译文件
    additionalModel: [Object, Array], // 自定义model
    moddleExtension: Object, // 自定义moddle
    onlyCustomizeAddi: {
      type: Boolean,
      default: false
    },
    onlyCustomizeModdle: {
      type: Boolean,
      default: false
    },
    processType: {
      type: String,
      default: "camunda"
    },
    events: {
      type: Array,
      default: () => ["element.click"]
    },
    headerButtonSize: {
      type: String,
      default: "small",
      validator: value => ["default", "medium", "small", "mini"].indexOf(value) !== -1
    },
    headerButtonType: {
      type: String,
      default: "primary",
      validator: value => ["default", "primary", "success", "warning", "danger", "info"].indexOf(value) !== -1
    }
  },
  data() {
    return {
      currentScale: "100%",
      defaultZoom: 1,
      previewModelVisible: false,
      previewResult: "",
      previewType: "xml",
      recoverable: false,
      revocable: false
    };
  },
  computed: {
    additionalModules() {
      const Modules = [];
      // 仅保留用户自定义扩展模块
      if (this.onlyCustomizeAddi) {
        if (Object.prototype.toString.call(this.additionalModel) === "[object Array]") {
          return this.additionalModel || [];
        }
        return [this.additionalModel];
      }

      // 插入用户自定义扩展模块
      if (Object.prototype.toString.call(this.additionalModel) === "[object Array]") {
        Modules.push(...this.additionalModel);
      } else {
        this.additionalModel && Modules.push(this.additionalModel);
      }

      // 翻译模块
      const TranslateModule = {
        translate: ["value", customTranslate(this.translations || translationsCN)]
      };
      Modules.push(TranslateModule);

      // 根据需要的流程类型设置侧边栏构建器
      // if (this.processType === "bpmn") {
      //   Modules.push(bpmnModdleExtension);
      // }
      if (this.processType === "camunda") {
        Modules.push(camundaModdleExtension);
      }
      if (this.processType === "flowable") {
        Modules.push(flowableModdleExtension);
      }
      if (this.processType === "activiti") {
        Modules.push(activitiModdleExtension);
      }

      return Modules;
    },
    moddleExtensions() {
      const Extensions = {};
      // 仅使用用户自定义模块
      if (this.onlyCustomizeModdle) {
        return this.moddleExtension || null;
      }

      // 插入用户自定义模块
      if (this.moddleExtension) {
        for (let key in this.moddleExtension) {
          Extensions[key] = this.moddleExtension[key];
        }
      }

      // 根据需要的 "流程类型" 设置 对应的解析文件
      if (this.processType === "activiti") {
        Extensions.activiti = activitiModdleDescriptor;
      }
      if (this.processType === "flowable") {
        Extensions.flowable = flowableModdleDescriptor;
      }
      if (this.processType === "camunda") {
        Extensions.camunda = camundaModdleDescriptor;
      }
      return Extensions;
    }
  },
  mounted() {
    this.initBpmnModeler();
    this.createNewDiagram(this.value);
    // this.$once("hook:beforeDestroy", () => {
    // });
  },
  beforeDestroy(){
    if (this.bpmnModeler) this.bpmnModeler.destroy();
    this.$emit("destroy", this.bpmnModeler);
    this.bpmnModeler = null;
  },
  methods: {
    //保存流程xml
    saveFlow(){
      this.bpmnModeler.saveXML({ format: true }).then(({ xml }) => {
        this.saveProcess(xml);
      });
    },
    saveProcess(xml){
      let params = {
        name:this.idName.name,
        key:this.idName.id,
        xml:xml,
      }
      debugger
      var this_ = this;
      this.http.ajaxHandler().success(function(code,msg){
        if(code==0){
          this_.$message({
            message: '保存成功',
            type: 'success'
          });
        }else{
          this_.$message({
            message: msg,
            type: 'warning'
          });
        }
      }).error(function (code,msg) {
        this_.$message.error(msg);
      }).post({url:"/workflow/process/saveProcess",data:params,headers:{ "content-type": "application/json" }});
    },
    initBpmnModeler() {
      if (this.bpmnModeler) return;
      this.bpmnModeler = new BpmnModeler({
        container: this.$refs["bpmn-canvas"],
        additionalModules: this.additionalModules,
        moddleExtensions: this.moddleExtensions
      });
      this.initModelListeners();
    },
    createNewDiagram(xml) {
      // 将字符串转换成图显示出来
      let xmlString = xml || DefaultEmptyXML(parseInt(new Date().getTime()/1000), "测试流程", this.processType);
      this.bpmnModeler.importXML(xmlString).then(result => {
          const { warnings } = result;
          if (warnings && warnings.length) console.warn(warnings);
          this.$emit("init-finished", this.bpmnModeler);
        })
        .catch(e => {
          console.error(e);
        });
    },
    initModelListeners() {
      const EventBus = this.bpmnModeler.get("eventBus");
      const that = this;
      // 注册需要的监听事件, 将. 替换为 - , 避免解析异常
      this.events.forEach(event => {
        EventBus.on(event, function(eventObj) {
          let eventName = event.replace(/\./g, "-");
          let element = eventObj ? eventObj.element : null;
          that.$emit(eventName, element, eventObj);
        });
      });
      // 监听图形改变返回xml
      EventBus.on("commandStack.changed", async () => {
        try {
          this.recoverable = this.bpmnModeler.get("commandStack").canRedo();
          this.revocable = this.bpmnModeler.get("commandStack").canUndo();
          let { xml } = await this.bpmnModeler.saveXML({ format: true });
          this.$emit("input", xml);
          this.$emit("change", xml);
        } catch (e) {
          console.error(e);
        }
      });
      // 监听视图缩放变化
      this.bpmnModeler.on("canvas.viewbox.changed", e => {
        this.defaultZoom = Math.floor(e.viewbox.scale * 100) / 100;
        this.currentScale = Math.floor(this.defaultZoom * 100) + "%";
      });
    },

    // 下载流程图到本地
    async downloadProcess(type) {
      try {
        const _this = this;
        // 按需要类型创建文件并下载
        if (type === "xml" || type === "bpmn") {
          const { err, xml } = await this.bpmnModeler.saveXML();
          // 读取异常时抛出异常
          if (err) {
            return console.error(err);
          }
          let { href, filename } = _this.setEncoded(type.toUpperCase(), xml);
          downloadFunc(href, filename);
        } else {
          const { err, svg } = await this.bpmnModeler.saveSVG();
          // 读取异常时抛出异常
          if (err) {
            return console.error(err);
          }
          let { href, filename } = _this.setEncoded("SVG", svg);
          downloadFunc(href, filename);
        }
      } catch (e) {
        console.error(e);
      }
      // 文件下载方法
      function downloadFunc(href, filename) {
        if (href && filename) {
          let a = document.createElement("a");
          a.download = filename; //指定下载的文件名
          a.href = href; //  URL对象
          a.click(); // 模拟点击
          URL.revokeObjectURL(a.href); // 释放URL 对象
        }
      }
    },

    // 根据所需类型进行转码并返回下载地址
    setEncoded(type, data) {
      const encodedData = encodeURIComponent(data);
      return {
        filename: `diagram.${type}`,
        href: `data:application/${type === "svg" ? "text/xml" : "bpmn20-xml"};charset=UTF-8,${encodedData}`,
        data: data
      };
    },

    // 加载本地文件
    importLocalFile() {
      const that = this;
      const file = this.$refs.refFile.files[0];
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function() {
        let xmlStr = this.result;
        that.createNewDiagram(xmlStr);
      };
    },
    /* ------------------------------------------------ refs methods ------------------------------------------------------ */
    downloadProcessAsXml() {
      this.downloadProcess("xml");
    },
    downloadProcessAsBpmn() {
      this.downloadProcess("bpmn");
    },
    downloadProcessAsSvg() {
      this.downloadProcess("svg");
    },
    processRedo() {
      this.bpmnModeler.get("commandStack").redo();
    },
    processUndo() {
      this.bpmnModeler.get("commandStack").undo();
    },
    processZoomIn() {
      this.defaultZoom = Math.floor(this.defaultZoom * 10 + 1) / 10;
      this.bpmnModeler.get("canvas").zoom(this.defaultZoom);
    },
    processZoomOut() {
      this.defaultZoom = Math.floor(this.defaultZoom * 10 - 1) / 10;
      this.bpmnModeler.get("canvas").zoom(this.defaultZoom);
    },
    processReZoom() {
      this.defaultZoom = 1;
      this.bpmnModeler.get("canvas").zoom("fit-viewport", "auto");
    },
    processRestart() {
      this.createNewDiagram(null);
    },
    previewProcessXML() {
      this.bpmnModeler.saveXML({ format: true }).then(({ xml }) => {
        this.previewResult = xml;
        this.previewType = "xml";
        this.previewModelVisible = true;
      });
    },
    previewProcessJson() {
      this.bpmnModeler.saveXML({ format: true }).then(({ xml }) => {
        this.previewResult = convert.xml2json(xml, { spaces: 2 });
        this.previewType = "json";
        this.previewModelVisible = true;
      });
    }
  },
  watch: {
    value: {
      handler: function(val) {
        this.createNewDiagram(val);
      }
    }
  }
};
</script>
